import React from 'react'
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import { XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';

function NotFound() {
  return (
    <div>
        
    <Header/> 
        <NotFoundComponent/>
    </div>
  )
}

export default NotFound

const NotFoundComponent = ({ contactName = "there" }) => {

  const navigate = useNavigate()
  const styles = {
    wrapper: {
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: "'Segoe UI', Roboto, sans-serif"
    },
    card: {
      maxWidth: '700px',
      width: '100%',
      backgroundColor: '#ffffff',
      borderRadius: '24px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      overflow: 'hidden',
      border: '1px solid #e2e8f0'
    },
    headerBar: {
      height: '8px',
      background: 'linear-gradient(90deg, #940d0d 0%, #0f172a 100%)' 
    },
    content: {
      padding: '40px 30px',
      textAlign: 'center'
    },
    iconCircle: {
      width: '80px',
      height: '80px',
      backgroundColor: '#fdf0f0',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginTop: '40px'
    },
    stepCard: {
      padding: '24px',
      backgroundColor: '#f8fafc',
      borderRadius: '16px',
      border: '1px solid #f1f5f9'
    },
    primaryBtn: {
      backgroundColor: '#0f172a',
      color: 'white',
      padding: '12px 32px',
      borderRadius: '50px',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
      fontSize: '16px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s'
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.headerBar} />
        
        <div style={styles.content}>
          <div style={styles.iconCircle}>
            <XCircle size={40} color="#940d0d" />
            </div>

          <h1 style={{ fontSize: '32px', color: '#0f172a', marginBottom: '16px', fontWeight: '800' }}>
            404
          </h1>
          
          <p style={{ fontSize: '18px', color: '#475569', lineHeight: '1.6', maxWidth: '500px', margin: '0 auto' }}>
            We can't find the page you're looking for.
          </p>

         

          <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
            <button 
              style={styles.primaryBtn}
              onMouseOver={(e) => e.target.style.backgroundColor = '#1e293b'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#0f172a'}
              onClick={()=>{navigate("/")}}
            >
              Return Home
            </button>
            
          </div>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#f8fafc', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
           {/* <ShieldCheck size={16} color="#94a3b8" /> */}
           <span style={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
             Lotus Accounting 
             {/* • Secure & Confidential */}
           </span>
        </div>
      </div>
    </div>
  );
};